import { Icon } from '@genial/components';
import { Circle } from 'native-base';
import React from 'react';
import { Pressable } from 'react-native';

import { InfoPanelTypes } from '..';

export const InfoPanelVisibleMobile: React.FC<
  InfoPanelTypes.Props & { onToggleAccordion: () => void }
> = ({ onToggleAccordion }) => {
  return (
    <Circle background="neutral.darkest" p="inset.nano">
      <Pressable onPress={onToggleAccordion}>
        <Icon name="UserCheckBroken" size="xxs" color="neutral.white" />
      </Pressable>
    </Circle>
  );
};
